import type {ExecutorPreviewData} from '@frontend/modules/public/services/ServicesModuleTypes'
import clsx from 'clsx'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {useUiLayoutStore} from '../../../../../stores'
import {ExecutorCommunicationButtons} from '../details/ExecutorCommunicationButtons'
import {ServicesListItemCoverImageAndIcons} from './ServicesListItemCoverImageAndIcons'
import {ServicesListItemInfo} from './ServicesListItemInfo'

interface Props {
    executor: ExecutorPreviewData
    example?: boolean
    className?: string
    onExecutorDataChange?: (executor: ExecutorPreviewData) => void
}

// Карточка предпросмотра исполнителя в категории услуг.
export function ServicesListItem(props: Props) {

    const {
        className,
        executor,
        example,
        onExecutorDataChange,
    } = props

    const bsSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    const deviceType = useUiLayoutStore(
        state => state.deviceType
    )

    return (
        <Card
            className={clsx(
                'executor-card',
                executor.isPromoted ? 'promoted border border-2 border-orange' : null,
                className
            )}
        >
            <CardBody
                className={clsx(
                    'p-3',
                    'd-flex flex-column gap-3 align-items-stretch justify-content-start',
                    'flex-xxl-row gap-xxl-4 align-items-xxl-start'
                )}
            >
                <div
                    className={clsx(
                        'd-flex flex-column gap-3 align-items-stretch justify-content-start',
                        'flex-sm-row gap-sm-4 align-items-sm-start',
                        'flex-md-column gap-md-3 align-items-sm-stretch',
                        'flex-lg-row gap-lg-4 align-items-lg-start',
                        'flex-xxl-1 flex-xxl-row gap-xxl-4 align-items-xxl-start'
                    )}
                >
                    <div>
                        <ServicesListItemCoverImageAndIcons
                            executor={executor}
                            example={example}
                        />
                        {!example && deviceType !== 'mobile' && bsSize !== 'md' && (
                            <div className="executor-card-actions d-flex flex-column align-items-center gap-4">
                                <ExecutorCommunicationButtons<ExecutorPreviewData>
                                    executor={executor}
                                    condensed
                                    onExecutorDataChange={onExecutorDataChange}
                                    className={clsx(
                                        'd-sm-flex flex-sm-row gap-sm-4',
                                        'd-md-block'
                                    )}
                                />
                            </div>
                        )}
                    </div>
                    <ServicesListItemInfo
                        executor={executor}
                        example={example}
                    />
                </div>
                {!example && (deviceType === 'mobile' || bsSize === 'md') && (
                    <div className="executor-card-actions mt-n3 d-flex flex-column align-items-center gap-4">
                        <ExecutorCommunicationButtons<ExecutorPreviewData>
                            executor={executor}
                            condensed
                            onExecutorDataChange={onExecutorDataChange}
                            className={clsx(
                                'd-sm-flex flex-sm-row gap-sm-4',
                                'd-md-block'
                            )}
                        />
                    </div>
                )}
            </CardBody>
        </Card>
    )
}
